import './components/CookieBar'
import './components/Lightbox'
import './pages/home'
import Menu from './components/Menu'

addEventListener('DOMContentLoaded', () => {
	// Check if mobile.
	if (navigator.maxTouchPoints > 1) {
		document.body.classList.add('mobile')
	}

	if (/(Google)/gi.test(navigator.vendor)) {
		document.body.classList.add('chromium')
	}

	configureAnalytics()
	initializeChapters()
	Menu.init()
})

// Send any analytics that can be gathered.
function configureAnalytics() {
	if (window.URL) {
		const url = new URL(window.location.href)
		if (url.searchParams.has('s')) {
			window.gtag?.('event', 'Search', {
				event_category: 'keywords',
				event_label: url.searchParams.get('s'),
			})
		}
	}

	const anchors = document.body.querySelectorAll('a[href$="pdf"], a[href$="zip"]')
	for (let a = 0; a < anchors.length; a++) {
		anchors[a].addEventListener('click', function (this: HTMLAnchorElement) {
			const filename = this.href.split('/').pop()
			window.gtag?.('event', 'Download', {
				event_category: filename,
				event_label: 'download',
			})
		})
	}
}

function initializeChapters() {
	let activeElement: HTMLElement
	const anchors = Array.from(document.querySelectorAll('ul.chapters-list a')) as HTMLElement[]

	addEventListener('click', (event) => {
		const target = event.target as HTMLElement
		activeElement?.classList.remove('expanded')

		if (anchors.includes(target)
			&& activeElement != target 
			&& target.parentElement.querySelector('ul.subitems')
		) {
			event.preventDefault()
			event.stopPropagation()
			activeElement = target
			target.classList.add('expanded')
		}
	})
}
